import moment from 'moment';

const {
    SYSLOG_TYPES,
    SYSLOG_PROTOCOLS,
    ALERTS_MANAGEMENT_OPTIONS_TYPES,
    INCIDENT_TYPE
} = require('@silverfort-nodelibs/common/utils/consts');
const {
    CUSTOMIZABLE_EVENTS,
    NOTIFICATION_EVENTS_SETTINGS
} = require('../../containers/AlertsManagement/components/AlertsOptionsConsts');
const { SILVERFORT_RECOMMENDED_EVENTS } = require('../Email/EmailConsts');

export const SYSLOG_CUSTOMIZABLE_EVENTS = new Set([
    ...CUSTOMIZABLE_EVENTS,
    SYSLOG_TYPES.AUTHENTICATIONS.id,
    SYSLOG_TYPES.NOTIFICATIONS.id,
    SYSLOG_TYPES.INTEGRATIONS.id
]);

const getTZLabel = (tz) => {
    const offset = moment.tz(tz).utcOffset();
    const hours = String(Math.floor(Math.abs(offset) / 60)).padStart(2, '0');
    const minutes = String(Math.abs(offset) % 60).padStart(2, '0');
    const sign = offset < 0 ? '-' : '+';
    return `UTC${sign}${hours}:${minutes} ${tz}`;
};

export const SYSLOG_EVENTS_SETTINGS = {
    ...NOTIFICATION_EVENTS_SETTINGS,
    [SYSLOG_TYPES.INTEGRATIONS.id]: {
        title: 'Splunk Application',
        desc: 'Select this option to send the events specific to the Silverfort Splunk app',
        optionType: ALERTS_MANAGEMENT_OPTIONS_TYPES.SELECT,
        options: moment.tz
            .names()
            .filter((tz) => !tz.includes('GMT'))
            .map((tz) => ({ label: getTZLabel(tz), value: tz }))
    }
};

export const DEFAULT_SYSLOG = {
    name: '',
    creationDate: Date.now(),
    target: '',
    port: 514,
    splunkTimezone: 'UTC',
    protocol: SYSLOG_PROTOCOLS.TCP.value,
    type: [],
    activeEvents: {
        [SYSLOG_TYPES.NEW_INCIDENT.id]: true,
        [SYSLOG_TYPES.RISK_LEVEL.id]: true,
        [SYSLOG_TYPES.SA_ALERTS.id]: true,
        [SYSLOG_TYPES.PA_ALERTS.id]: true,
        [SYSLOG_TYPES.AUTHENTICATIONS.id]: true,
        [SYSLOG_TYPES.AUDIT.id]: true
    },
    settings: {
        [SYSLOG_TYPES.RISK_LEVEL.id]: SYSLOG_EVENTS_SETTINGS[SYSLOG_TYPES.RISK_LEVEL.id].defaultSelections,
        [SYSLOG_TYPES.NEW_INCIDENT.id]: SYSLOG_EVENTS_SETTINGS[SYSLOG_TYPES.NEW_INCIDENT.id].defaultSelections.filter(
            (selection) => selection !== INCIDENT_TYPE.LOG4SHELL.value
        ),
        [SYSLOG_TYPES.NEW_INSIGHT.id]: SYSLOG_EVENTS_SETTINGS[SYSLOG_TYPES.NEW_INSIGHT.id].defaultSelections,
        [SYSLOG_TYPES.AUTHENTICATIONS.id]: SYSLOG_EVENTS_SETTINGS[SYSLOG_TYPES.AUTHENTICATIONS.id].defaultSelections,
        [SYSLOG_TYPES.NOTIFICATIONS.id]: {
            default: { eventIds: SILVERFORT_RECOMMENDED_EVENTS.map((e) => e.value) },
            custom: { eventIds: [], severity: [] }
        }
    }
};
